/**
 * Structural Summary — placeholder statement (matches the Operational /
 * Security panels' pattern).
 *
 * The aggregate tile grid (UX/endpoint/flow counts, confidence bars,
 * hotspots, per-project table, graph metrics) wasn't earning its dashboard
 * space — the numbers lacked actionable context at the cross-project level.
 * The full implementation lives in git history (#819 originally; removed in
 * the same style as the OperationalSummary reduction for v1.0) — restore
 * from there when the redesigned cross-project structural view lands.
 *
 * Per-project structural data is unaffected: ProjectSummary on each
 * project's page still renders the live payload.
 */

import { getBugReportConfig } from '../../utils/bugReportLink';

export function StructuralSummary() {
  const { enabled, href } = getBugReportConfig();
  return (
    <section
      id="structural-summary"
      data-testid="structural-summary"
      data-placeholder="true"
      tabIndex={-1}
      className="mb-8 border border-border rounded-lg p-6 bg-muted/20 scroll-mt-20"
    >
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h2 className="text-xl font-semibold flex items-center gap-2">
            Structural summary
            <span className="text-[10px] px-1.5 py-0.5 rounded uppercase tracking-wide bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300">
              Being redesigned
            </span>
          </h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-xl">
            We&apos;re rethinking this panel — aggregate counts across projects
            weren&apos;t giving you anything to act on. Each project&apos;s page
            has the live structural picture (flows, endpoints, graphs, and
            evidence); a clearer cross-project view of structural health is on
            the way. We&apos;d love to hear what you&apos;d find most useful.
          </p>
        </div>
        {enabled && (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline whitespace-nowrap"
          >
            Suggest what this should show
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        )}
      </div>
    </section>
  );
}
